<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.no" placeholder="business.label.loadingOrderNo" type="search" @search-click="refresh"/>
        <vxe-input v-model="query.deliverer" placeholder="business.label.deliver" type="search" @search-click="refresh"/>
        <vxe-date-picker v-model="dateFilter.start" placeholder="placeholder.startTime" type="date" value-format="yyyy-MM-dd" @change="refresh"/>
        <vxe-date-picker v-model="dateFilter.end" placeholder="placeholder.endTime" type="date" value-format="yyyy-MM-dd" @change="refresh"/>
      </template>
      <vxe-table ref="orderTable" :data="orders" :loading="loading" @cell-click="({row})=>rowClick(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.no" title="business.label.loadingOrderNo" width="150"/>
        <vxe-column field="order.invoiceTime" title="business.label.generatedTime" width="170"/>
        <vxe-column field="order.operator" title="business.label.operator"/>
        <vxe-column field="carrier.name" title="business.label.carrierName" width="200"/>
        <vxe-column field="carrier.expressCode" title="business.label.expressCode" width="100"/>
        <vxe-column field="order.numberOfOrder" title="business.label.orderCount"/>
        <vxe-column field="order.numberOfCustomer" title="business.label.customerCount"/>
        <vxe-column field="order.deliverer" title="business.label.deliver"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="order.coldChains" title="business.label.coldChains" width="60"/>
        <vxe-column field="dock.no" title="business.label.dock"/>
        <vxe-column field="vehicle.no" title="business.label.vehicleNo"/>
        <vxe-column field="order.driver" title="business.label.driver"/>
        <vxe-column field="order.driverPhone" title="business.label.phone"/>
        <vxe-column field="vehicle.type" title="business.label.vehicleType"/>
        <vxe-column field="order.vehicleInPlaceStatus" title="business.label.vehicleInPlaceStatus"/>
        <vxe-column field="order.departureTime" title="business.label.departureTime" width="170"/>
        <vxe-column field="order.notes" title="business.label.notes"/>
      </vxe-table>
      <vxe-pager :current-page="page" :loading="loading" :page-size="size" :pageSizes="[5, 10, 15, 20]" :total="contentSize" @page-change="pageChange"/>
      <vxe-table ref="detailTable" :data="details" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="customer.no" title="business.label.customerNo" width="100"/>
        <vxe-column field="customer.name" title="business.label.customerName" width="300"/>
        <vxe-column field="pickupMode.name" title="business.label.shipmentMode" width="80"/>
        <vxe-column field="detail.wave" title="business.label.wave" width="100"/>
        <vxe-column field="detail.ordinal" title="business.label.orderOfLoading" width="60"/>
        <vxe-column field="statistics.numberOfItem" title="business.label.numberOfItem" width="60"/>
        <vxe-column field="statistics.numberOfFcl" title="business.label.numberOfFcl" width="60"/>
        <vxe-column field="statistics.numberOfLcl" title="business.label.numberOfLcl" width="60"/>
        <vxe-column field="statistics.numberOfEach" title="business.label.numberOfEach" width="60"/>
        <vxe-column field="statistics.numberOfRefrigeration" title="business.label.numberOfRefrigeration" width="60"/>
        <vxe-column field="statistics.numberOfValuable" title="business.label.numberOfValuable" width="60"/>
        <vxe-column field="statistics.numberOfImportation" title="business.label.numberOfImportation" width="60"/>
        <vxe-column field="statistics.numberOfPsychotropic" title="business.label.numberOfPsychotropic" width="60"/>
        <vxe-column field="statistics.numberOfSpecial" title="business.label.numberOfSpecial" width="60"/>
        <vxe-column field="statistics.numberOfPeptides" title="business.label.numberOfPeptides" width="60"/>
        <vxe-column field="statistics.numberOfGift" title="business.label.numberOfGift" width="60"/>
        <vxe-column field="statistics.numberOfOthers" title="business.label.numberOfOthers" width="60"/>
        <vxe-column field="statistics.numberOfSupervised" title="business.label.numberOfSupervised" width="60"/>
        <vxe-column field="statistics.standardCaseQuantity" title="business.label.standardCaseQuantity" width="100"/>
        <vxe-column field="statistics.volume" title="business.label.volume" width="100"/>
        <vxe-column field="statistics.weight" title="business.label.weight" width="100"/>
        <vxe-column field="statistics.amount" title="business.label.amount" width="100"/>
        <vxe-column field="statistics.numberOfPlasticBox" title="business.label.numberOfPlasticBox" width="60"/>
        <vxe-column field="statistics.numberOfCartonBox" title="business.label.numberOfCartonBox" width="60"/>
        <vxe-column field="statistics.numberOfInsulationBox" title="business.label.numberOfInsulationBox" width="60"/>
      </vxe-table>
    </vxe-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import { findAll } from '@/api/Api'
import { LoadingOrder } from '@/api/dto/order/LoadingOrder'
import { DatePicker } from '@/api/dto/view/DatePicker'

export default {
  name: 'Issued',
  data() {
    return {
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      dateFilter: new DatePicker(),
      query: new LoadingOrder(),
      order: new LoadingOrder(),
      orders: [],
      details: [],
      page: 1,
      size: 5,
      contentSize: 0
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('loadingOrderFactory', { ...this.query.toJSONObject(), orderStatus: 54, dateFilter: this.dateFilter }, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.orders = res.result
          if (this.orders.length > 0) {
            const current = this.orders[0]
            this.$refs.orderTable.setRadioRow(current)
            this.$refs.orderTable.setCurrentRow(current)
            this.rowClick(current)
          }
        }
      }).finally(() => this.loading = false)
    },
    getDetails() {
      this.loading = true
      findAll('loadingDetailFactory', { 'order.id': this.order.id }).then(res => {
        if (res.success) {
          this.details = res.result
        }
      }).finally(() => this.loading = false)
    },
    rowClick(row) {
      this.order = new LoadingOrder(row.order)
      this.getDetails()
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.dateFilter = new DatePicker()
      this.query = new LoadingOrder()
      this.refresh()
    }
  }
}
</script>